// extracted by mini-css-extract-plugin
export default {"melodyVideo":"RQ-z","isFullWidth":"SQ-z","landingPageVideo":"TQ-z","play":"UQ-z","iframeVideo":"VQ-z","playHidden":"WQ-z","fullwidth":"XQ-z"};